import {
  LIST_RESERVATION_AVAILABILITIES_REQUEST,
  RESET_RESERVATION_AVAILABILITY,
  RESERVATION_CLICK_SUCCESS_GTM
} from './constants';

export const listReservationAvailabilities = (queryString, viewType) => ({
  type: LIST_RESERVATION_AVAILABILITIES_REQUEST,
  queryString,
  viewType
});

export const resetReservationAvailability = () => ({
  type: RESET_RESERVATION_AVAILABILITY
});

export const reservationClick = (payload) => ({
  type: RESERVATION_CLICK_SUCCESS_GTM,
  payload
});
